import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { actionAddPelletsInScreenCenterAnimation } from "../../animation/actionPelletAnimations";
import { IdIcon } from "../../generic/icon/IdIcon";
import { actionInventoryInfoRemoveResource } from "../../info/inventory/actionInventoryInfo";
import { actionOutskirtsInfoUpdateImprovementInfo } from "../../info/outskirts/actionOutskirtsInfo";
import { actionPlayerInfoAddBuffs } from "../../info/player/actionPlayerInfo";
import { TypeActionImprovement, } from "../actionImprovement";
import { mapOutskirtIdToImprovementInfo } from "../mapOutskirtIdToImprovementInfo";
export var epicBuyImprovementRequest = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionImprovement.BuyRequest), switchMap(function (action) {
        var playerId = state$.value.playerInfo.playerId;
        return deps
            .netSend({
            id: mapOutskirtIdToImprovementInfo.get(action.buildingId).command,
            props: {
                improvementId: action.id,
                playerId: playerId,
                useHardCurrency: action.premium,
            },
        })
            .pipe(retry(), switchMap(function (res) {
            var actions = [];
            var reward = [
                {
                    amount: 1,
                    icon: IdIcon.ImprovementIcn,
                },
            ];
            actions.push(actionAddPelletsInScreenCenterAnimation(res.improvement.improvementId, reward));
            actions.push(actionPlayerInfoAddBuffs(res.buff));
            actions.push(actionInventoryInfoRemoveResource(res.cost));
            actions.push(actionOutskirtsInfoUpdateImprovementInfo(action.buildingId, res.improvement));
            return from(actions);
        }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/improvement/epics/epicBuyImprovementRequest.ts
// module id = 1895
// module chunks = 3